import {
  BreadcrumbModel,
  EntityStatusModel,
  PreferencesState,
} from '@abb-procure/data';
import { BooleanInput } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  booleanAttribute,
  inject,
  input,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { EntityService } from '../../services/entity.service';
import { Card } from '../card/card.component';
import { ConfidentialIcon } from '../confidential-icon/confidential-icon.component';
import {
  FormHeaderUploads,
  UploadFieldProgress,
} from '../form-header-uploads/form-header-uploads.component';
import { LoadingIndicator } from '../loading-indicator/loading-indicator.component';
import { PageHeaderStatuses } from '../page-header-statuses/page-header-statuses.component';
import { PageHeaderTitle } from '../page-header-title/page-header-title.component';
import { PageHeaderTopbar } from '../page-header-topbar/page-header-topbar.component';

@Component({
  selector: 'procure-page-header',
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  imports: [
    MatIcon,
    LoadingIndicator,
    PageHeaderTopbar,
    PageHeaderTitle,
    PageHeaderStatuses,
    FormHeaderUploads,
    Card,
    ConfidentialIcon,
  ],
  host: {
    '[attr.title]': '""',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeader {
  readonly entityClickable = input<boolean, BooleanInput>(true, {
    transform: booleanAttribute,
  });

  readonly url = input<string | null>();
  readonly sapAribaLink = input<string | null>();
  readonly orbisLink = input<string | null>();
  readonly sncrpLink = input<string | null>();
  readonly gravityLink = input<string | null>();
  readonly xapienLink = input<string | null>();
  readonly ecoVadisLink = input<string | null>();
  readonly tooltip = input<string>();
  readonly control = input<FormControl>();
  readonly title = input<string>();
  readonly fallbackTitle = input<string>();
  readonly revision = input<string>();
  readonly status = input<EntityStatusModel | null>();
  readonly statusColor = input<string | null>();
  readonly additionalStatus = input<string | null>();
  readonly uploadFieldsProgress = input<UploadFieldProgress[]>([]);
  readonly breadcrumbs = input<BreadcrumbModel[] | null>(null);
  readonly label = input<string>('Name');
  readonly maintenanceText = input<string | null>();
  readonly template = input<string | null>();

  readonly isLoading = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isTitleEditable = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly autofocusTitle = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly fileUploadsPending = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly isAdmin = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly hideHeader = input<boolean, BooleanInput>(false, {
    transform: booleanAttribute,
  });

  readonly confidentiality = input<string>();
  readonly internal = input<string>();
  readonly priority = input<number | null>();

  protected readonly preferences = inject(PreferencesState);
  protected readonly entityService = inject(EntityService);
}
